import React from 'react';
import Checkbox from '../../../atoms/Checkbox/Checkbox';
import List from '../List';
import {StyledSubcategory} from './styles';
import Props from './typings';

const CheckList = ({options, selected, group, style = 'text', callback}: Props) => {
  const defaultOption = 'all';
  const checkedOptions = selected.map((option) => option.value);

  const optionIsSelected = (option) => {
    if (selected.length === 0) {
      return option === defaultOption;
    } else {
      return checkedOptions.includes(option);
    }
  };

  const selectedSubcategories = (parentOption) => {
    if (!checkedOptions.includes(parentOption)) return [{value: defaultOption}];

    // Values need to be unique
    const selection = selected.filter((option) => option.value === parentOption)[0];
    if (selection.subcategories && selection.subcategories.length > 0) {
      return [...selection.subcategories];
    } else {
      return [{value: defaultOption}];
    }
  };

  const combineResponse = (subSelection, parent) => {
    if (checkedOptions.includes(parent)) {
      const selection = selected.map((option) => {
        if (option.value === parent) option.subcategories = subSelection;
        return option;
      });
      callback(selection);
    }
  };

  const buttonResponse = (resp) => {
    let selectedList;
    if (checkedOptions.includes(resp)) {
      selectedList = selected.filter((option) => option.value !== resp);
    } else {
      selectedList = [...selected, {value: resp}];
    }
    callback(selectedList);
  };

  return (
    <>
      {options.map((option, key) => (
        <React.Fragment key={key}>
          {option.value && (
            <Checkbox
              checked={optionIsSelected(option.value)}
              label={option.label}
              value={option.value}
              group={group}
              callback={buttonResponse}
              style={style}
            />
          )}

          {option.sublist && (
            <StyledSubcategory
              $visible={!option.value ? true : checkedOptions.includes(option.value)}
            >
              <List
                type={option.sublist.type}
                style={option.sublist.style}
                group={option.value + ''}
                selected={selectedSubcategories(option.value)}
                options={option.sublist.options}
                callback={(resp) => combineResponse(resp, option.value)}
              />
            </StyledSubcategory>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

export default CheckList;
